import script from "./xshzDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./xshzDetails.vue?vue&type=script&setup=true&lang=js"

import "./xshzDetails.vue?vue&type=style&index=0&id=015d9fa0&lang=less"

const __exports__ = script;

export default __exports__